<div class="countable-dialog confirmation-dailog" (click)="$event.stopPropagation()">
    <div mat-dialog-title class="dialog-header d-flex flex-column align-items-start p-4 pb-0 mb-2">
        <ngx-avatars initialsSize="2" size="72" [name]="avatarText()" [bgColor]="selectedColor()" fgColor="rgba(0, 0, 0, 0.8)">
        </ngx-avatars>
        <h3 class="title">Change Color</h3>
    </div>

    <div mat-dialog-content class="content dialog-body-content text-center gap-8">
        <div class="card px-3">
            <div class="color-grid gap-20">
                @for(color of colors(); track color){
                <div class="color-circle" [style.background-color]="color" [class.selected-v2]="color === selectedColor()"
                    (click)="selectColor(color)"></div>
                }
            </div>
        </div>

    </div>

    <div mat-dialog-actions class="dialog-footer button-group" (click)="$event.stopPropagation()">
        <button mat-button mat-stroked-button (click)="cancel()" color="dark" class="button-normal">Cancel</button>
        <button mat-button mat-flat-button color="primary" class="button-normal" (click)="confirm()" [disabled]="isChangedDisabled()">Change
            Color</button>
    </div>
</div>